export default __webpack_public_path__ + "static/media/WAS0360.34I-38290_-22502_0.260ce14e.jpg";